import { Popover, Transition } from "@headlessui/react";
import { BellIcon, EyeIcon } from "@heroicons/react/24/outline";
import { relativeDate } from "@prmf/site-utils";
import { Link } from "@remix-run/react";
import { useEffect, useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { useProfile } from "./ProfileProvider";

export default function NotificationsButton() {
  const { messages } = useProfile();
  const [filtered, setFiltered] = useState(messages);
  const [showUnread, setShowUnread] = useState(false);

  useEffect(() => {
    setFiltered(messages.filter((m) => (showUnread ? m.readAt : !m.readAt)));
  }, [messages, showUnread]);

  const hasNew = messages.filter((m) => !m.readAt).length > 0;
  return (
    <Popover className="relative z-20 mt-1">
      <Popover.Button className="relative outline-none">
        <BellIcon className="size-5" />
        {hasNew && (
          <span className="absolute right-0 top-0 size-2 rounded-full bg-red-500" />
        )}
      </Popover.Button>
      <Transition
        as={Fragment}
        enterFrom="opacity-0 -translate-y-3"
        leaveTo="opacity-0 -translate-y-2"
      >
        <Popover.Panel className="absolute right-0 mt-2 w-64 overflow-hidden rounded bg-white text-black shadow transition">
          <div className="max-h-[500px] divide-y overflow-auto">
            {filtered.map((m) => (
              <Popover.Button
                as={Link}
                key={m.id}
                className="grid gap-2 px-4 py-3 hover:bg-blue-50"
                to={`/account/messages/${m.id}`}
              >
                <div className="space-y-1">
                  <h4 className="font-medium">{m.title}</h4>
                  <p className="text-neutral-800">{m.text}</p>
                </div>
                <span>{relativeDate(m.createdAt)}</span>
              </Popover.Button>
            ))}
          </div>
          {!showUnread && !hasNew && (
            <div className="p-4">
              <h4 className="font-medium">No new messages.</h4>
              <p>You're all caught up! 👏</p>
            </div>
          )}
          {messages.length > 0 && !hasNew && (
            <div className="p-1">
              <button
                className="flex w-full grow items-center justify-center gap-2 rounded border border-neutral-300 p-2"
                onClick={() => setShowUnread((p) => !p)}
              >
                <span>Show {showUnread ? "unread" : "read"} messages</span>
                <EyeIcon className="size-4" />
              </button>
            </div>
          )}
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}
